import React from "react";

const SectionHeading = ({ eyebrow, title, copy, align = "left", className = "" }) => {
  const alignment = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-3xl ${alignment} ${className}`}>
      {eyebrow && <div className="eyebrow mb-5">{eyebrow}</div>}
      {title && (
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-ivory leading-[1.1] tracking-tight text-balance">
          {title}
        </h2>
      )}
      {copy && (
        <p className="mt-6 text-grey-soft text-base md:text-lg leading-relaxed max-w-2xl">
          {copy}
        </p>
      )}
    </div>
  );
};

export default SectionHeading;
